// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from 'react';
import { classNames } from '@plasmicapp/react-web';

export type DeviderIconProps = React.ComponentProps<'svg'> & {
  title?: string;
};

export function DeviderIcon(props: DeviderIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={'http://www.w3.org/2000/svg'}
      fill={'none'}
      viewBox={'0 0 897 1'}
      height={'1em'}
      width={'1em'}
      style={{
        stroke: 'currentcolor',

        ...(style || {}),
      }}
      className={classNames('plasmic-default__svg', className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path stroke={'currentColor'} d={'M0 .5h897'}></path>
    </svg>
  );
}

export default DeviderIcon;
/* prettier-ignore-end */
